import { StrapiProductMedia, StrapiImageMedia, StrapiVideoMedia } from './types';

export function isImageMedia(media?: StrapiProductMedia): media is StrapiImageMedia {
  return media?.media?.data?.attributes.mime.startsWith('image/') ?? false;
}

export function isVideoMedia(media?: StrapiProductMedia): media is StrapiVideoMedia {
  return media && 'video' in media && media.video !== null;
}
